import React from 'react';
import './Loader.css'; // Import the CSS file created above

const Loader = ({ isLoading, text = "Initializing Quantum Core..." }) => {
  
  // If not loading, return nothing (or manage this via parent conditional rendering)
  if (!isLoading) return null;

  return (
    <div className="loader-overlay" role="status" aria-live="polite">
      <div className="spinner-box">
        {/* The Outer Blue Ring */}
        <div className="leo-border-1"></div>
        
        {/* The Inner Purple Ring */}
        <div className="leo-border-2"></div>
        
        {/* The Glowing Core */}
        <div className="leo-core"></div>
      </div>
      
      {/* Dynamic Text */}
      <div className="loading-text">{text}</div>
    </div>
  );
};

export default Loader;